var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MChart',{ref:"chart",attrs:{"series":_vm.metricSeries,"options":_vm.chartOptions,"height":_vm.height}})}
var staticRenderFns = []

export { render, staticRenderFns }